import { render, staticRenderFns } from "./treatment.vue?vue&type=template&id=53081aee&"
import script from "./treatment.vue?vue&type=script&lang=js&"
export * from "./treatment.vue?vue&type=script&lang=js&"
import style0 from "./treatment.vue?vue&type=style&index=0&id=53081aee&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports